import { render, staticRenderFns } from "./StakeHistoryBlock.vue?vue&type=template&id=36f9bc82&scoped=true&"
import script from "./StakeHistoryBlock.vue?vue&type=script&lang=js&"
export * from "./StakeHistoryBlock.vue?vue&type=script&lang=js&"
import style0 from "./StakeHistoryBlock.vue?vue&type=style&index=0&id=36f9bc82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f9bc82",
  null
  
)

export default component.exports